<template>
  <div class="flex-grow-1 min-h-0 d-flex flex-column overflow-auto">
    <h6 class="mb-4 text-gray-700">Детали полиса</h6>
    <policy-bpm-summary
      :policy="policy"
      :mode="mode"
      :module="module"
      :dictionaries="dictionaries"
      :duration="duration"
    />
    <policy-bpm-card v-if="hasCalculatedPremium && policy.calculationDate">
      <template v-slot:calculation>
        <div class="position-relative w-100 d-flex flex-column gap-3">
          <premium-calculation-bpm-collapse
            :calculation="policy.premiumCalculation"
            :policy="policy"
            :module="module"
          />
          <div class="rounded border border-primary border-dashed bg-light-primary p-2 p-md-3">
            <div class="d-flex flex-column flex-sm-row gap-3 justify-content-md-end">
              <div class="w-100">
                <div class="text-gray-600 fs-8 mb-1">Итого к оплате</div>
                <div class="fw-bold fs-5 text-gray-800 text-nowrap">
                  {{ formatMoneyRu(premiumSummary.total) }}
                  <span class="fw-normal fs-7 text-gray-600">тг.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </policy-bpm-card>
  </div>
</template>

<script>
import PolicyBpmCard from '@/components/Form/Bpm/Policy/PolicyBpmCard.vue'
import PolicyBpmSummary from '@/components/Form/Bpm/Policy/PolicyBpmSummary.vue'
import PremiumCalculationBpmCollapse from '@/components/Form/Bpm/Policy/PremiumCalculationBpmCollapse.vue'

export default {
  name: 'BpmOgpoSummaryStep',
  components: {
    PolicyBpmCard,
    PolicyBpmSummary,
    PremiumCalculationBpmCollapse,
  },
  props: {
    policy: {
      type: Object,
      required: true,
    },
    mode: {
      type: [Object, Function],
      required: true,
    },
    module: {
      type: Function,
      required: true,
    },
    dictionaries: {
      type: Object,
      required: true,
    },
    duration: {
      type: Object,
      default: null,
    },
    hasCalculatedPremium: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'reset-calculation',
  ],
  computed: {
    premiumSummary() {
      return this.module.PremiumCalculation.getSummary(this.policy.premiumCalculation, this.policy)
    },
  },
  methods: {
    formatDateRu(date) {
      if (!date) {
        return ''
      }
      const d = new Date(date)
      if (Number.isNaN(d.getTime())) {
        return ''
      }
      return d.toLocaleDateString('ru-RU')
    },
    formatMoneyRu(value) {
      return this.module.PremiumCalculation.formatMoney(value)
    },
  },
}
</script>
